module.exports = __webpack_public_path__ + "static/media/icon-new-progress-incorrect-unattempted.89606e05.svg";